import React from 'react'
import { Link, useNavigate } from 'react-router-dom';

const NurserylevelCard = (props) => {
  const { icon, title, count, percentage, className, duration, img, navigateTo } = props
  const navigate = useNavigate();

  const handleChange = () => {
    navigate(navigateTo)
  };
  return (
    <div className={className}>
      <div className="card light-shadow mb-0 n_shadows a_card cursor-pointer  " >
        {/* <a  className="card-body" onClick={() => handleChange()}> */}
        <a className="card-body" onClick={handleChange} >
          <div className="stats ">
            <div className='row '>
              <div className='col-9'>
                <h2 className='ml-2 ' style={{color:'#4067ae'}}>{count}</h2>
                <p className='green' style={{ fontWeight: "900", marginBottom: "-15px" }}>{title}</p>
              </div>
              <div className='col-lg-3'>
                <span className="icon ">
                  <img className='imageiconbg icon_edit mt-3 mt-lg-0 ' src={img} style={{ height: "50px" }} />
                </span>
              </div>
            </div>
          </div>
          
        </a>
      </div>
    </div>
  )
}

export default NurserylevelCard
